module.exports = __webpack_public_path__ + "static/media/ScoreBoard.e41faa3d.woff2";